export const PHRASE_PROJECT_URL = 'https://eu.phrase.com/'

// export const {
//   REACT_APP_PHRASE_API_URL: PHRASE_API_URL,
//   REACT_APP_PHRASE_PROJECT_ID: PHRASE_PROJECT_ID,
//   REACT_APP_PHRASE_TOKEN: PHRASE_TOKEN,
//   REACT_APP_PHRASE_ENGLISH_ID: PHRASE_ENGLISH_ID,
// } = process.env;
export const {
  VITE_PHRASE_API_URL: PHRASE_API_URL,
  VITE_PHRASE_PROJECT_ID: PHRASE_PROJECT_ID,
  VITE_PHRASE_TOKEN: PHRASE_TOKEN,
  VITE_PHRASE_ENGLISH_ID: PHRASE_ENGLISH_ID,
} = import.meta.env

export const DEFAULT_LANGUAGES = [{ label: 'English', value: 'en' }]

// Valid languages in Phrase
export const SUPPORTED_LANGUAGES = [
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'de-FT',
  'en',
  'en-DE',
  'en-GB',
  'fi-FI',
  'fr-BE',
  'fr-CH',
  'fr-FR',
  'fr-CA',
  'hu-HU',
  'ja-JP',
  'kw-GB',
  'nl-BE',
  'nl-NL',
  'no-NO',
  'pl-PL',
  'sv-SE',
  'ro-RO',
  'en-US',
  'en-CA',
  'en-AU',
  'en-ZA',
  'el-GR',
  'en-GR'
]

export const FALLBACK_LANGUAGES = {
  en: 'en',
  de: 'de-DE',
  hu: 'hu-HU',
  no: 'no-NO',
  pl: 'pl-PL',
  sv: 'sv-SE',
  fi: 'fi-FI',
  fr: 'fr-FR',
  nl: 'nl-NL',
  cs: 'cs-CZ',
  da: 'da-DK',
  ja: 'ja-JP',
  kw: 'kw-GB',
  ro: 'ro-RO',
}

export const AllLanguages = Object.keys(FALLBACK_LANGUAGES)

// Sort by length (longest first) to ensure specific locales like "en-DE" match before shorter ones like "en"
export const SupportedLocales = [...SUPPORTED_LANGUAGES, ...AllLanguages].sort(
  (a, b) => b.length - a.length,
)

export const LocalePattern = SupportedLocales.join('|')

const canonicalLocaleMap = new Map(
  SupportedLocales.map((locale) => [locale.toLowerCase(), locale]),
)

export const findLocaleInUrl = (url) => {
  const match = url.match(new RegExp(`/(?<locale>${LocalePattern})`, 'i'))
  if (!match?.groups?.locale) return undefined

  const detectedLocale = match.groups.locale
  return canonicalLocaleMap.get(detectedLocale.toLowerCase()) || detectedLocale
}

export const removeLanguageFromUrl = (url) => {
  for (const locale of SupportedLocales) {
    const prefix = `/${locale}`
    const prefixRegex = new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&')}(?:/|$)`, 'i')
    
    if (prefixRegex.test(url)) {
      // Remove the matched prefix (case-insensitive)
      const remaining = url.replace(prefixRegex, '')
      return remaining
        .replace(/\/+$/, '/')
        .replace(/^\//, '')
        .replace(/\/$/, '')
    }
  }

  return url
    .replace(/\/+$/, '/')
    .replace(/^\//, '')
    .replace(/\/$/, '')
}

export const replaceLanguageInUrl = (url, language) => {
  const urlWithoutLanguage = removeLanguageFromUrl(url)
  if (urlWithoutLanguage) {
    return `/${language}/${urlWithoutLanguage}`
  }
  return `/${language}`
}
